import { blue, grey } from '@material-ui/core/colors';
import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

const Theme = createTheme({
  sidebar: {
    width: 262,
  },
  typography: {
    fontFamily: 'Helvetica, Roboto , inter, Arial , sans-serif',
    button: {
      textTransform: 'none'
    }
  },
  palette: {
    primary: {
      main: '#BF1D2D',
      light: 'none !important',
      dark: '#BF1D2D',
      contrastText: '#ffffff',
    },
    DarkRed: {
      main: '#BF1D2D',
      light: '#BF1D2D',
      dark: '#BF1D2D',
      contrastText: '#ffffff',
    },
    secondary: {
      main: grey[500],
      light: grey[500],
      dark: grey[500],
      contrastText: '#ffffff',
    },
    // transparent: {
    //   main: 'transparent',
    //   light: 'transparent',
    //   dark: 'transparent',
    //   contrastText: '#000',
    // },
    lightGreen: {
      main: '#E1EDE8',
      light: '#E1EDE8',
      dark: '#E1EDE8',
      contrastText: '#000',
    },
    lightRed: {
      main: '#EDE1E1',
      light: '#EDE1E1',
      dark: '#EDE1E1',
      contrastText: '#000',
    },
    blue: {
      main: '#143EF6',
      light: '#143EF6',
      dark: '#143EF6',
      contrastText: '#fff',
    },
    red: {
      main: '#E62719',
      light: '#E62719',
      dark: '#E62719',
      contrastText: '#fff',
    },
    DarkGreen: {
      main: '#01784F',
      light: '#01784F',
      dark: '#01784F',
      contrastText: '#fff',
    },
  },
  components: {
    MuiAccordion: {
      variants: [
        {
          props: { variant: 'incident' },
          style: {
            margin: '0',
            border: '1px solid #E1E1E1',
            borderRadius: '8px !important',
            boxShadow: 'none',
            '&:before': {
              display: 'none',
            },
            '&.Mui-expanded': {
              margin: '0',
            },
            '& .MuiCollapse-root': {
              transitionDuration: '0.2s !important',
            },
          },
        },
      ],
    },
    MuiAccordionSummary: {
      variants: [
        {
          props: { variant: 'incident' },
          style: {
            padding: 16,
            margin: 0,
            '&.Mui-expanded': {
              minHeight: 'auto',
            },
            '& .MuiAccordionSummary-content': {
              margin: 0,
              '&.Mui-expanded': {
                margin: 0,
              },
            },
          },
        },
      ],
    },
    MuiAccordionDetails: {
      variants: [
        {
          props: { variant: 'incident' },
          style: {
            padding: 0,
            paddingTop: '16px',
          },
        },
      ],
    },
    MuiTabs: {
      variants: [
        {
          props: { variant: 'navigation' },
          style: {
            minHeight: 'auto',
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          },
        },
      ],
    },
    MuiTab: {
      variants: [
        {
          props: { variant: 'navigation' },
          style: {
            backgroundColor: '#f3f3f3',
            color: '#333333',
            borderRadius: '50px',
            padding: '8px 20px',
            margin: '0 4px',
            minHeight: 'auto',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 'normal',
            '&:hover': {
              backgroundColor: 'rgba(191, 29, 45, 0.1)',
            },
            '&.Mui-selected': {
              backgroundColor: 'rgba(191, 29, 45, 0.8)',
              borderRadius: '40px',
              color: '#fff',
              '&:hover': {
                backgroundColor: 'rgba(191, 29, 45, 0.9)',
              },
            },
          },
        },
      ],
    },
  },
});

export default Theme;
